import { useEffect } from "react";

import { FeatureFlag } from "../../constants/featureFlags";
import { useFeatureFlag } from "../../hooks/useFeatureFlag";
import { MemoryMonitorService } from "../../services/posthog/MemoryMonitorService";

export function MemoryMonitorController(): null {
  const isMemoryMonitorEnabled = useFeatureFlag(FeatureFlag.MemoryMonitor);

  useEffect(() => {
    if (!isMemoryMonitorEnabled) return;
    const service = MemoryMonitorService.getInstance();
    service.start();
    return () => service.stop();
  }, [isMemoryMonitorEnabled]);

  return null;
}
